module.exports = __webpack_public_path__ + "media/images/doctor-06adfa942d6d54b44688198f26684411.svg";